import Vue from 'vue'
import {
  axios
} from '@/utils/request'

const state = {
}

const getters = {
  theDict: state => type => state[`${type}`] || {}
}

const mutations = {
  update(state, payload) {
    for (const key in payload) {
      Vue.set(state, key, payload[key])
    }
  },
}

const actions = {
  async getDict({
    commit,
    dispatch,
    state,
  }, type) {
    if (state[type] && type !== 'group') {
      return state[type]
    }
    const data = {}
    switch (type) {
      case 'group':
        const { records } = await axios.get('/p/material/web/group', { params: { size: 1000 } })
        const theData = {}
        records.forEach(item => {
          theData[item.id] = item.title
        })
        data[type] = theData
        break
      case 'domainTrans':
        const trans = await axios.get('/p/web/domain/trans')
        data[type] = trans
        break
      case 'orgOptions':
        const oot = await axios.get('/p/web/org/options')
        const orgOptionsData = {}
        oot.forEach(item => {
          orgOptionsData[item.optionId] = item.optionName
        })
        data[type] = orgOptionsData
        break
      case 'province':
        const pro = await axios.get('p/web/geoArea/children')
        const proData = {}
        pro.forEach(item => {
          proData[item.id] = item.areaName
        })
        data[type] = proData
        break
      default:
        const rz = await axios.get(`/p/web/dict/trans/${type}`)
        data[type] = rz
    }
    commit('update', data)
    return data[type]
  },
  async getDictLessee({
    commit,
    dispatch,
    state,
  }, type) {
    // if (state[type] && type !== 'group') {
    //   return state[type]
    // }
    const data = {}
    switch (type) {
      case 'group':
        const records = await axios.get('/p/web/tenantTableRoleGroup/options')
        const theData = {}
        records.forEach(item => {
          theData[item.id] = item.groupName
        })
        data[type] = theData
        break
      case 'trans':
        const trans = await axios.get('/p/web/org/trans')
        data[type] = trans
        break
      case 'orgOptions':
        const oot = await axios.get('/p/web/org/options')
        const orgOptionsData = {}
        oot.forEach(item => {
          orgOptionsData[item.optionId] = item.optionName
        })
        data[type] = orgOptionsData
        break
      default:
        const rz = await axios.get(process.env.VUE_APP_API_BASE_STATEMODULE + `/dict/parent/${type}`)
        data[type] = rz
    }
    commit('update', data)
    return data[type]
  },
  async removeDict({
    commit,
    dispatch,
    state,
  }, type) {
    const data = {}
    data[type] = false
    commit('update', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
